import { Conversation } from "@twilio/conversations";
import log from "loglevel";
import { Dispatch } from "redux";
import { ACTION_END_CHAT, ACTION_UPDATE_CONVERSATION_STATE } from "../actionTypes";
import { getTasks } from "../taskActions";


export const initConversationListener = (conversation: Conversation, dispatch: Dispatch) => {
    conversation.addListener("updated", ({ conversation: updatedConversation, updateReasons }) => {

        // we are listening only to a subset of events.
        if (updateReasons?.includes("state")) {            
            //Get last chatted queue detais from conversation when chat is closed
            if (updatedConversation?.state?.current === "closed") {
                const conversationSid = conversation.sid
                if (conversationSid) {
                    getTasks({ conversationSid })
                        .then(async (response) => response.json())
                        .then((result) => {
                            if (result?.length > 0) {
                                const allMatchingChannels = result.filter((task: Record<string, unknown>) => {
                                    const attributes = (task.attributes as string) || "";
                                    return (
                                        attributes.includes(conversationSid) && !attributes.includes("MonitoredBy")
                                    );
                                });

                                if (allMatchingChannels?.length > 0) {
                                    dispatch({
                                        type: ACTION_END_CHAT,
                                        payload: {
                                            lastQueueId: allMatchingChannels[allMatchingChannels.length-1].taskQueueSid,
                                            lastQueueName: allMatchingChannels[allMatchingChannels.length-1].taskQueueFriendlyName
                                        }
                                    });
                                    dispatch({
                                        type: ACTION_UPDATE_CONVERSATION_STATE,
                                        payload: { conversationState: updatedConversation?.state?.current }
                                    });                                    
                                };
                            }
                        })
                        .catch(err => {
                            log.error(err);
                        });
                }
            }
            else {
                dispatch({
                    type: ACTION_UPDATE_CONVERSATION_STATE,
                    payload: { conversationState: updatedConversation?.state?.current }
                });
            }
        }

    });
};
